import { builder as classBuilder } from './class-bridge/builder.js';
import { builder as functionalBuilder } from './functional-bridge/builder.js';
function isClassComponent(component) {
    return typeof component === 'function' && !!component.prototype.isReactComponent;
}
function ReactEngineBridge(component, metadata) {
    if (isClassComponent(component)) {
        return classBuilder(component, metadata);
    }
    return functionalBuilder(component, metadata);
}
export { ReactEngineBridge, };
//# sourceMappingURL=react-engine-bridge.js.map